// Mobile Menu
(function ($) {
    $('.mobile-nav .hamburger').mousedown(function (e) {
        e.preventDefault();
    });

    $('.mobile-nav .hamburger').click(function () {
        $(this).toggleClass('is-active');
        $(this).parent('nav').toggleClass('is-active');
    });
    $('.slider-main').slick({
        arrows: false,
        asNavFor: '.slider-nav',
        lazyLoad: 'ondemand',
        centerMode: true,
        variableWidth: true,
        focusOnSelect: true,
    });
    $('.slider-nav').slick({
        focusOnSelect: true,
        asNavFor: '.slider-main',
        arrows: false,
        slidesToShow: 4,
        variableWidth: true,
        centerMode: true,
        centerPadding: 0,
        draggable: false,
    });
    $('.article__images').slick({
        arrows: true,
        lazyLoad: 'progressive',
        focusOnSelect: true,
    });

})(jQuery);